/** @jsx jsx */
import { jsx } from 'theme-ui';

export function FlowerHeading({ title, staticImage, msx }) {
	return (
		<div sx={{ position: 'relative', textAlign: 'center', mt: 5 }}>
			{staticImage}
			<div
				sx={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					width: '100%',
					fontFamily: 'Oswald',
					fontStyle: 'normal',
					fontWeight: 'bold',
					fontSize: 54,
					lineHeight: '100%',
					transform: 'translate(-50%, -50%)',
					fontSize: 7,
					textShadow: '4px 5px 0px #383838',
					color: 'white',
					letterSpacing: '0.07em',
					backgroundColor: '#ffffff3d',
					/* padding:20, */
					paddingBottom: 30,
					paddingTop: 20,
					...msx
				}}
			>
				{title}
			</div>
		</div>
	);
}
